import loadable from '@/components/common/Loadable';

export const GamesPage = loadable(() => import('@/pages/Games'));
export const NotFoundPage = loadable(() => import('@/pages/NotFound'));
export const SessionUnavailablePage = loadable(() => import('@/pages/SessionUnavailable'));
export const CasinoResultsPage = loadable(() => import('@/pages/CasinoResults'));
